import { render, staticRenderFns } from "./newInsureDetail.vue?vue&type=template&id=41e62b18&scoped=true"
import script from "./newInsureDetail.vue?vue&type=script&lang=js"
export * from "./newInsureDetail.vue?vue&type=script&lang=js"
import style0 from "./newInsureDetail.vue?vue&type=style&index=0&id=41e62b18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41e62b18",
  null
  
)

export default component.exports